import { useParams } from 'react-router-dom'

import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import { addRegionToPath } from 'lib/url/searchUrlUtils'
import { getTripURL } from 'tripPlanner/utils'

function TripTabRedirect() {
  const { regionCode = '', tripId = '' } = useParams<'regionCode' | 'tripId'>()

  return <RedirectWithStatus
    code={301}
    to={addRegionToPath(getTripURL(tripId), regionCode)}
  />
}

export default TripTabRedirect
